import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

interface Props {
  open: boolean;
  infoRequired: string | null;
  handler: string;
  context: string;
  associatedLogId: number;
}

export interface HandedByDetailProps {
  handler: string;
  infoRequired: string | null;
}

// Define the initial state using that type
const initialState: Props = {
  open: false,
  infoRequired: null,
  handler: '',
  context: '',
  associatedLogId: -1,
};

export const handleErrorSlice = createSlice({
  name: 'handleError',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    openDialog: (state, action: PayloadAction<HandedByDetailProps>) => {
      state.open = true;
      state.infoRequired = action.payload.infoRequired;
      state.handler = action.payload.handler;
    },
    setContext: (state, action: PayloadAction<string>) => {
      state.context = action.payload;
    },
    setAssociatedLogId: (state, action: PayloadAction<number>) => {
      state.associatedLogId = action.payload;
    },
    closeDialog: (state) => {
      state.open = false;
    },
  },
});

export const { openDialog, closeDialog, setContext, setAssociatedLogId } = handleErrorSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectOpen = (state: RootState) => state.handleError.open;
export const selectInfoRequired = (state: RootState) => state.handleError.infoRequired;
export const selectContext = (state: RootState) => state.handleError.context;
export const selectHandler = (state: RootState) => state.handleError.handler;
export const selectAssociatedLogId = (state: RootState) => state.handleError.associatedLogId;

export default handleErrorSlice.reducer;
